import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const DetailContainer = styled.div`
  padding: 8px;
  overflow: auto;
`;

const Span = styled.span`
  margin-left: 10px;
`;

const SpanTitle = styled.span`
  text-transform: capitalize;
  color: gray;
`;

const LinkImage = styled.a`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 30px !important;
  border: none;
  margin-top: 80px;
  outline-style: none;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;
const LinkImageDetailing = styled.a`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  border: none;
  outline-style: none;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

export { Container, DetailContainer, Span, SpanTitle, LinkImage, LinkImageDetailing };
